// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/driver/DriverEntry"),
  iconType: "team",
  name: "driver",
  subApps: [
    {
      name: "search",
      requirePermission: "driver-registry:view"
    },
    {
      name: "invitations",
      requirePermission: "driver-registry:view"
    },
    {
      name: "permits",
      requirePermission: "driver-registry:view"
    },
    {
      name: "applications",
      requirePermission: "driver:applications"
    }
  ]
}: AppType)
